/**
 * Handles the shaft heights select options to display, depending on the left-foot-size value selected
 */
(function () {
    //get the element(size) that defines what the shaft Heights options should be displayed
    var productSize = document.getElementById('left-foot-size');
    //get the Id of the Shaft Heights that will display the options
    var shaftHeightsList = 'shaft-heights';

    //call functions to update the options for the default value for productSize
    removeShaftHeightsOptions(shaftHeightsList);
    updateShaftHeightsSelect(productSize.value);

    if (productSize != null ){
        //add event to update shaft-heights when left-foot-size changes
        productSize.addEventListener('change',function(){
            var value = this.value;
            //var text = this.options[this.selectedIndex].text;

            removeShaftHeightsOptions(shaftHeightsList);
            updateShaftHeightsSelect(value);
        });
    }

    /**
     * Removes all the option on the select to then update all the values
     * @param {string} selectId the id of the select to update, in this case shaft-heights
     */
    function removeShaftHeightsOptions(selectId) {
        var i,
        select = document.getElementById(selectId);
        L = select.options.length - 1;
        for(i = L; i >= 0; i--) {
            select.remove(i);
        }
    }

    /**
     * Creates a list of options for the select element given, with the list provided
     * @param {string} selectId the element Id to be updated witht the list of options
     * @param {Array} shaftHeightsOptions The array of options to be added to the select input
     */
    function createShaftHeightsOptions(selectId,shaftHeightsOptions){

        var select = document.getElementById(selectId);

        for (var i = 0; i<shaftHeightsOptions.length; i++){
            var opt = document.createElement('option');
            opt.value = shaftHeightsOptions[i];
            opt.innerHTML = shaftHeightsOptions[i];//create object with the list of elements
            select.appendChild(opt);
        }
    }

    /**
     * Updates the list of options depending of the size selected(value)
     * @param {number} value the size on productSize
     */
    function updateShaftHeightsSelect(value){
        if (value >= 4 && value <= 4.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [35cm]','Petite [30cm]'])
        }else if (value >= 5 && value <= 5.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [36cm]','Petite [31cm]']);
        }else if (value >= 6 && value <= 6.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [37cm]','Petite [32cm]']);
        }else if (value >= 7 && value <= 7.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [38cm]','Petite [33cm]']);
        }else if (value >= 8 && value <= 8.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [39cm]','Petite [34cm]']);
        }else if (value >= 9 && value <= 9.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [40cm]','Petite [35cm]']);
        }else if (value >= 10 && value <= 10.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [41cm]']);
        }else if (value >= 11 && value <= 11.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [42cm]']);
        }else if (value >= 12 && value <= 12.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [43cm]']);
        }else if (value >= 13 && value <= 13.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [44cm]']);
        }else if (value >= 14 && value <= 14.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [45cm]']);
        }else if (value >= 15 && value <= 15.5){
            createShaftHeightsOptions(shaftHeightsList,['Standard [46cm]']);
        }
    }

})()
